/**
 * 使用量の日次一覧（アカウント別・指定期間内）の Query Hook
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getUsageDailyAuthenticated } from '@/lib/api/usage/usageAggregation';
import { usageAggregationKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * アカウント別の日次一覧を取得する Query Hook（account が空の間は発火しない）
 */
export function useUsageDaily(account: string, from?: string, to?: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: usageAggregationKeys.daily(account, from ?? '', to ?? ''),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getUsageDailyAuthenticated(authHeaders, account, from, to);
    },
    enabled: !authHeaderLoading && isAuthorized && !!account,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
